import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateOrganizationRequest } from '@nucleus-commerce/api-client/platform';

import { organizationsApi } from '../api/organizations-api';

import { organizationKeys } from './organization-keys';

/**
 * POST /platform/v1/organizations: creates the organization, its owner and first store in one
 * call. The response is not the detail shape, so the detail page fetches it on arrival.
 */
export function useProvisionOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateOrganizationRequest) => organizationsApi.provision(input),
    meta: { successMessage: 'organizations:toasts.provisioned' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: organizationKeys.lists() }),
  });
}
